export enum DocumentTypeEnum {
    NDA = 1,
    ReferralAgreementYes = 2,
    ReferralPartnerNDA = 3,
    W9ScheduleDocument = 4,
    AdminManualUpload = 5,
    ReferralAgreementNs = 6,
    ReferralAgreementNp = 7,
}
